<template>
  <BaseTableColumn v-bind="attrs"
                   v-on="$listeners"
                   :header="header"
                   :rows="rows"
                   :width="width">
    <template v-slot:header="props">
      <slot name="header">
        <div :style="innerHeaderContainerStyle">
          {{ props.header }}
        </div>
      </slot>
    </template>
    <template v-slot:row="props">
      <slot name="row"
            :index="props.index"
            :row="props.row">
        <div :style="innerRowContainerStyle">
          {{ props.row }}
        </div>
      </slot>
    </template>
  </BaseTableColumn>
</template>

<script>
  import BaseTableColumn from '@base/base-table-column'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TableColumnPrimary',
    inheritAttrs: false,
    components: {
      BaseTableColumn,
    },
    props: {
      header: { type: String, required: false, default: '' },
      rows: { type: Array, required: false, default: () => [] },
      truncate: { type: Boolean, required: false, default: false },
      width: { type: String, required: false, default: '100%' },
    },
    data: function () {
      return {
        attrs: {
          backgroundColor: 'transparent',
        },
        innerHeaderContainerStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.xl,
        },
        innerRowContainerStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
        },
        truncateStyle: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        headerContainerStyle: {
          alignItems: 'center',
          color: this.color.dark2(),
          display: 'flex',
          height: '37px',
          justifyContent: 'flex-start',
          padding: `0 ${Layout.space.sm}`,
        },
        rowContainerStyle: {
          alignItems: 'center',
          border: `solid ${this.color.dark5()}`,
          borderWidth: '1px 0 0 0',
          color: this.color.dark2(),
          display: 'flex',
          height: '56px',
          justifyContent: 'flex-start',
          padding: `0 ${Layout.space.sm}`,
        },
        ...this.$attrs,
      };

      this.innerHeaderContainerStyle = {
        ...this.innerHeaderContainerStyle,
        color: this.color.dark3(),
        ...(this.truncate ? this.truncateStyle : {}),
      };

      this.innerRowContainerStyle = {
        ...this.innerRowContainerStyle,
        color: this.color.dark2(),
        ...(this.truncate ? this.truncateStyle : {}),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
